import { Routes } from '@angular/router';

import { ERoutes, UtilityRoutes } from '../../types/app-routes';
import { CardCanDeactivateGuard } from '../../services/card-can-deactivate-guard.service';

export const documentsRoutes: Routes = [
  {
    path: ERoutes.AWARD_REQUEST_CASE,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./documents-table/documents-table.component').then(
            (m) => m.DocumentsTableComponent
          ),
      },
      {
        path: UtilityRoutes.CARD,
        canDeactivate: [CardCanDeactivateGuard],
        loadComponent: () =>
          import('./documents-card/documents-card.component').then((m) => m.DocumentsCardComponent),
      },
    ],
  },
];
